import $ from "jquery";
// import Swiper JS
import Swiper, { Navigation, Pagination } from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';

// configure Swiper to use modules
Swiper.use([Navigation, Pagination]);

$('.size_filter_e0db__slider').each(function(){
  var $element = $(this);
  var $pagination = $(this).find('.swiper-pagination');
  var $scrollbar = $(this).find('.swiper-scrollbar');

  new Swiper($element[0], {
    slidesPerView: 2,
    spaceBetween: 6,

    // If we need pagination
    // pagination: {
    //   el: $pagination[0],
    //   clickable: true,
    // },
    scrollbar: {
      el: $scrollbar[0],
      draggable: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 3,
      },
      540: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 5,
      },
      1024: {
        slidesPerView: 7,
      },
    }
  
  });

});

function filterProducts(ids) {
  if(ids.length == 0) {
    $('.products_ce12__product').addClass('show');
    return;
  }
  if(ids.length > 0) {
    $('.products_ce12__product').removeClass('show');
    ids.forEach(function(id){
      $('.products_ce12__product').each(function(){
        if ($(this).attr('data-product-id') == id.product) {
          $(this).addClass('show');
        }
      });
    });
  }
}

$('.size_filter_e0db__button').on('click', function() {
  var ids =  JSON.parse($(this).attr('data-products'));
  filterProducts(ids);
  $('.size_filter_e0db__button').removeClass('active');
  $(this).addClass('active');
});

